export const MASKS = {
  phone: ['(##) ####-####', '(##) #####-####'],
  phoneMX: ['##-####-####', '###-####-####'],
  date: ['##/##/####'],
  cpf: ['###.###.###-##'],
  cnpj: ['##.###.###/####-##'],
};
